/*
 * Reorders the list of games for a special 2-row swimlane layout.
 * Normally, games are rendered in a zigzag vertical order:
 * odd indexes go to the top row, even — to the bottom.
 * This function adjusts the order so that:
 * - the first 3 games appear in the top row,
 * - the next 3 games go to the bottom row,
 * - and the rest continue in a zigzag pattern (7th to top, 8th to bottom, and so on).
 */

import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'

export const format2RowSwimlane = (games: Array<GameProductShort>) => {
  const result = []
  const orderList = [0, 3, 1, 4, 2, 5]

  // handle the first 6 games manually if they are present
  for (let i = 0; i < orderList.length; i++) {
    if (orderList[i] < games.length) {
      result[i] = games[orderList[i]]
    }
  }

  // then continue from the 7th game
  for (let i = 6; i < games.length; i++) {
    result.push(games[i])
  }

  return result
}
